// extracted by mini-css-extract-plugin
export default {"Form":"PasswordResetPage_Form__7ZKLj","Disclaimer":"PasswordResetPage_Disclaimer__SGCzu","Btn":"PasswordResetPage_Btn__vfAGH"};